import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface CookieConsent {
  necessary: true;
  analytics: boolean;
  functional: boolean;
  timestamp: string;
}

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  showBanner$ = new Subject<void>();

  private readonly COOKIE_NAME = 'cookie_consent';
  private readonly MAX_AGE_SECONDS = 13 * 30 * 24 * 60 * 60; // ~13 mois

  getConsent(): CookieConsent | null {
    const raw = this.getCookie(this.COOKIE_NAME);
    if (!raw) return null;
    try {
      return JSON.parse(atob(raw));
    } catch {
      return null;
    }
  }

  hasConsent(category: 'analytics' | 'functional'): boolean {
    const consent = this.getConsent();
    if (!consent) return false;
    return consent[category];
  }

  setConsent(choices: { analytics: boolean; functional: boolean }): void {
    const consent: CookieConsent = {
      necessary: true,
      analytics: choices.analytics,
      functional: choices.functional,
      timestamp: new Date().toISOString(),
    };
    const value = btoa(JSON.stringify(consent));
    document.cookie = `${this.COOKIE_NAME}=${value}; path=/; max-age=${this.MAX_AGE_SECONDS}; SameSite=Lax`;
  }

  revokeConsent(): void {
    document.cookie = `${this.COOKIE_NAME}=; path=/; max-age=0`;
    this.showBanner$.next();
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
}
